module.exports = __webpack_public_path__ + "img/shejishi.aada3dfe.png";